var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('div',{staticClass:"header",class:{
      'header--freeze':
        _vm.mobileMenuShown || _vm.dataStoriesTagFilterShown || _vm.grantShowFilterMobile,
    }},[_c('Header')],1),_c('div',{staticClass:"content",class:{
      'content--freeze': _vm.mobileMenuShown || _vm.dataStoriesTagFilterShown,
    }},[_c('router-view')],1),_c('div',{staticClass:"footer",class:{ hidden: _vm.mobileMenuShown || _vm.grantShowFilterMobile }},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }